module.exports = __webpack_public_path__ + "img/toilet-paper-blank.031ae7d2.svg";